import { put, call } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';
import { setRedirect } from 'auth/actions';
import { insurancePurchase } from 'app/routes';

export function* insurancePurchaseNavigate({ purchaseId, contractId }) {
  yield put(setRedirect(insurancePurchase(purchaseId, contractId)));
  yield call(authenticateUser);
};

